// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file {
    position: relative;
}
.file img {
    width: 100%;
}
.file .remove {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1000;
}
.file .remove svg {
    width: 24px;
    height: 24px;
    opacity: 0.75;
    color: var(--primary-color-lightest);
    filter: drop-shadow(0 0 0 rgba(0 0 0 / 0.75))
}
`, "",{"version":3,"sources":["webpack://./client/components/files/DraftImageFile.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC;AACJ","sourcesContent":[".file {\n    position: relative;\n}\n.file img {\n    width: 100%;\n}\n.file .remove {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    z-index: 1000;\n}\n.file .remove svg {\n    width: 24px;\n    height: 24px;\n    opacity: 0.75;\n    color: var(--primary-color-lightest);\n    filter: drop-shadow(0 0 0 rgba(0 0 0 / 0.75))\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
